import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { MUZAIC_ROOT } from './config';
import './index.css';

// Set the CSS variable dynamically
document.documentElement.style.setProperty('--root-url', MUZAIC_ROOT);

// // Example of using the CSS variable for a background image
// document.body.style.backgroundImage = `url(${MUZAIC_ROOT}img/slice2_1.svg)`;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
